import CargoCompanyListRequest, {
  CargoCompanyListRequestOrder,
} from "../../../../api/raily/cargo-company/cargo-company/list/cargo-company-list.request";
import CargoCompanyListParams, {
  CargoCompanyListParamsOrder,
} from "./cargo-company-list-params";

const createOrder = (
  status: CargoCompanyListParamsOrder | undefined,
): CargoCompanyListRequestOrder | undefined => {
  switch (status) {
    case CargoCompanyListParamsOrder.COMPANY_NAME_ASC:
      return CargoCompanyListRequestOrder.COMPANY_NAME_ASC;
    case CargoCompanyListParamsOrder.COMPANY_NAME_DESC:
      return CargoCompanyListRequestOrder.COMPANY_NAME_DESC;
    case CargoCompanyListParamsOrder.COMPANY_DISPLAY_NAME_ASC:
      return CargoCompanyListRequestOrder.DISPLAY_NAME_ASC;
    case CargoCompanyListParamsOrder.COMPANY_DISPLAY_NAME_DESC:
      return CargoCompanyListRequestOrder.DISPLAY_NAME_DESC;
    default:
      return undefined;
  }
};

const create = (params: CargoCompanyListParams): CargoCompanyListRequest => {
  return {
    companyName: params.companyName,
    creationEnd: params.creationEnd,
    creationStart: params.creationStart,
    displayName: params.companyDisplayName,
    krsNo: params.nationalCourtRegister,
    notes: params.notes,
    order: createOrder(params.order),
    regon: params.companyId,
    taxId: params.taxNumber,
    headquartersAddressString: params.address,
  };
};

const cargoCompanyListParamsFactory = {
  create,
};

export default cargoCompanyListParamsFactory;
